import React from "react";
import { Route } from "react-router-dom";
import ProfileLayout from "./ProfileLayout";
import GeneralTab from "./GeneralTab/GeneralTab";
import SettingsTab from "./SettingsTab/SettingsTab";
import SettingsForm from "./SettingsTab/SettingsForm";
import PasswordTab from "./PasswordTab/PasswordTab";
import ContactTab from "./ContactTab/ContactTab";
import BioTab from "./BioTab/BioTab";
import EmailsTab, { emailsTabLoader } from "./EmailsTab/EmailsTab";
import SocialsTab from "./SocialsTab/SocialsTab";
import ImageTab from "./ImageTab/ImageTab";
import {
  sessionTextLongDescription,
  sessionTextShortDescription,
  sessionView,
} from "../../api/session";
import { testSessionLoader } from "../../loaders/helpers";

const profileComponentLoader = async () => {
  await (() => setTimeout(null, 1));
  const userEntityRes = await sessionView();
  const shortDescriptionRes = await sessionTextShortDescription();
  const longDescriptionRes = await sessionTextLongDescription();
  return { userEntityRes, shortDescriptionRes, longDescriptionRes };
};

const profileRoutes = (
  <Route
    id="profileComponent"
    loader={profileComponentLoader}>
    <Route
      index
      element={<GeneralTab/>}
      loader={testSessionLoader}
    />
    <Route
      path="settings"
      element={<SettingsTab/>}
      loader={testSessionLoader}
    />
    <Route
      path="update"
      element={<SettingsForm/>}
      loader={testSessionLoader}
    />
    <Route
      path="password"
      element={<PasswordTab/>}
      loader={testSessionLoader}
    />
    <Route
      path="contact"
      element={<ContactTab/>}
      loader={testSessionLoader}
    />
    <Route
      path="bio"
      element={<BioTab/>}
      loader={testSessionLoader}
    />
    <Route
      path="emails"
      element={<EmailsTab/>}
      loader={emailsTabLoader}
    />
    <Route
      path="socials"
      element={<SocialsTab/>}
      loader={testSessionLoader}
    />;
    <Route
      path="image"
      element={<ImageTab/>}
      loader={testSessionLoader}
    />
  </Route>);

const ProfileComponent = ({ ...props }) => {
  return <ProfileLayout {...props}/>;
};

export { profileRoutes };
export default ProfileComponent;